const inputFields = document.querySelectorAll(
  '.form input, .form textarea, .form select, filter-textfield input, filter-textfield label'
)

inputFields.forEach((inputField) => {
  if (inputField.type === 'file') {
    return
  }

  inputField.addEventListener('mousedown', (event) => {
    event.stopPropagation();
    inputFields.forEach((field) => {
      if (!field.value) {
        field.classList.remove('click-focus')
      }
    })

    inputField.classList.add('click-focus')
  })

  inputField.addEventListener('change', () => {
    if (inputField.value) {
      inputField.classList.add('click-focus')
    } else {
      inputField.classList.remove('click-focus')
    }
  })

  inputField.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      inputFields.forEach((field) => {
        if (!field.value) {
          field.classList.remove('click-focus')
        }
      })
    }
  })
})

document.addEventListener('mousedown', (event) => {
  if (!event.target.matches('.form input, .form textarea, .form select')) {
    inputFields.forEach((inputField) => {
      if (!inputField.value) {
        inputField.classList.remove('click-focus')
      }
    })
  }
})
